export type DataLayerEvent = {
  event: string;
  [key: string]: unknown;
};

export enum AnalyticsEventNames {
  AutopayCompleted = 'Autopay Completed',
  AutopayFailed = 'Autopay Failed',
  AutopayStarted = 'Autopay Started',
  BuyMoreInitiated = 'Buy More Initiated',
  BuyMoreOrderFailed = 'Buy More Order Failed',
  BuyMoreOrderSuccessful = 'Buy More Order Successful',
  BuyMoreSelected = 'Buy More Selected',
  ChangePlanInitiated = 'Change Plan Initiated',
  ChangePlanNotSupported = 'Change Plan Order Not Supported',
  ChangePlanOrderFailed = 'Change Plan Order Failed',
  ChangePlanOrderSuccess = 'Change Plan Order Successful',
  ChangePlanSelected = 'Change Plan Selected',
  DownloadAppIconClicked = 'Download App Icon Clicked',
  FeedbackButton = 'Feedback Button Clicked',
  OneTimePaymentCompleted = 'Payments One Time Payment Completed',
  OneTimePaymentFailed = 'Payments One Time Payment Failed',
  OneTimePaymentStarted = 'Payments One Time Payment Started',
  CancelSubscriptionInitiated = 'Cancel Subscription Initiated',
  SelectedPlan = 'Selected plan',
  SelectedRetentionOffer = 'Selected retention offer',
  Disconnected = 'Disconnected',
  CIFOrderInitiated = 'CIF Order Initiated',
}

export enum DataLayerEventName {
  LINK = 'link',
  FORM_START = 'form_start',
  FORM_SUBMIT = 'form_submit',
  PAGE_VIEW = 'page_view',
}

export enum ScriptId {
  ADOBE_TARGET = 'adobe-target',
}

export enum Categories {
  DataUsage = 'Data Usage',
  DownloadAppIcon = 'Download App Icon',
  Feedback = 'Feedback',
  PlanDetails = 'Plan Details',
  Alert = 'Alert',
  BuyMore = 'Buy More',
  Billing = 'Billing',
  ChangePlan = 'Change Plan',
  Profile = 'Profile',
  Login = 'Login',
  ShieldAd = 'Shield Ad',
  UsageSummaryBuyMore = 'Usage Summary Buy More',
  Disconnect = 'Disconnect',
}
